import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-wash',
  templateUrl: './section-wash.component.html',
  styleUrls: ['./section-wash.component.css']
})
export class SectionWashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
